import { useState } from 'react';
import { X } from 'lucide-react';

import ForgotPassword from './ForgotPassword';
import PasswordOtp from './PasswordOtp';
import ResetPasswordModal from './ResetPasswordModal';

type ForgotPasswordLayoutProps = {
  onClose: () => void;
};
function ForgotPasswordLayout({ onClose }: ForgotPasswordLayoutProps) {
  const [step, setStep] = useState('email');

  return (
    <div>
      <div className="fixed inset-0 z-50 bg-overlay/50"></div>
      <div className="bg-surface fixed top-[50%] left-[50%] z-50 grid w-full max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] gap-4 rounded-lg  p-6 shadow-lg sm:max-w-md">
        {step === 'email' && <ForgotPassword setStep={setStep} />}
        {step === 'otp' && <PasswordOtp setStep={setStep} />}
        {step === 'resetPwd' && <ResetPasswordModal />}
        <button
          type="button"
          className="absolute top-4 right-4 rounded-xs opacity-70 transition-opacity hover:opacity-100 focus:outline-hidden disabled:pointer-events-none
                                [&_svg]:pointer-events-none
                                [&_svg]:shrink-0
                                [&_svg:not([class*='size-'])]:size-4
                                cursor-pointer
                            "
          onClick={onClose}
        >
          <X />
        </button>
      </div>
    </div>
  );
}

export default ForgotPasswordLayout;
